import { render, staticRenderFns } from "./field.vue?vue&type=template&id=d538fc12&scoped=true"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"
import style0 from "./field.vue?vue&type=style&index=0&id=d538fc12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d538fc12",
  null
  
)

export default component.exports